// extracted by mini-css-extract-plugin
export var container = "_4t-0";
export var error = "_4t-9";
export var label = "_4t-5";
export var light = "_4t-6";
export var md = "_4t-3";
export var sm = "_4t-2";
export var thin = "_4t-8";
export var thinBold = "_4t-7";
export var vertical = "_4t-4";
export var xs = "_4t-1";